import { computed, effect, Injectable } from '@angular/core';
import { ServiceTypeEnum } from '../../../../../../../../../types/src/services/enum/service-type.enum';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { routeParams } from '../../../../../shared/shared.global-service';

@Injectable()
export class ServiceWaitingListModalStore extends ComponentStoreV2Factory {

    public service = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(routeParams.serviceId)());

    public isHealthCare = computed(() => this.service()?.type === ServiceTypeEnum.HEALTH_CARE);
    public isSocial = computed(() => this.service()?.type === ServiceTypeEnum.SOCIAL);

    public serviceType = computed(() => this.data.getServiceTypes()?.items?.[0] || null);

    constructor() {
        super();
        effect(() => {
            const id = this.service()?.serviceTypeId;
            if (!id) return;

            this.api.getServiceTypes(FilterBuilder.filterById(id));
        });
    }

}
